import { defineStore } from 'pinia'
import type { IRecruitment, IRecruitmentParams } from '@ui/interfaces/recruitment'

export const useRecruitmentStore = defineStore('recruitments', {
  state: (): IRecruitment => ({
    recruitment: [] as IRecruitmentParams[],
  }),
  getters: {
    getRecruitments(): IRecruitmentParams[] {
      return this.recruitment
    },
  },
  actions: {
    setRecruitment(data: IRecruitmentParams[]) {
      this.recruitment = data
    },
  },
})
